(function(angular) {
    THF.Angular.JoinForm.directive("disablePaste", [function() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                if( attrs.disablePaste == 'true' ) {
                    angular.element(elem).on("paste", function (e) {
                        e.preventDefault();
                    });
                }
            }
        }
    }]);
})(angular);